export const data = [
  {
    name: 'SENSEX',
    options: {
      apiField: 'SENSEX',
      precision: 2
    }
  },
  {
    name: 'NIFTY 50',
    options: {
      apiField: 'NIFTY',
      precision: 2
    }
  },
  {
    name: 'NIFTY BANK',
    options: {
      apiField: 'BANKNIFTY',
      precision: 2
    }
  },
  {
    name: 'BSE MIDCAP',
    options: {
      apiField: 'MIDCAP',
      precision: 2
    }
  },
  {
    name: 'NIFTY IT',
    options: {
      apiField: 'NIFTYIT',
      precision: 2
    }
  },
  {
    name: 'BSE 500',
    options: {
      apiField: 'BSE500',
      precision: 2
    }
  },
  {
    name: 'DOLLAR RUPEE',
    options: {
      apiField: 'USD - Indian Rupee',
      precision: 4,
      getChangeValuePrefix: val => (val >= 0 ? '+' : ''),
      isPositiveSentiment: val => val <= 0
    }
  },
  {
    name: 'INDIA 10YR YIELD',
    options: {
      apiField: 'India',
      precision: 4,
      flip: true
    }
  }
];
